(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('dashboardEventsList', ["path", "$q", "securityEventsDao", "tablePaginationHelper", "defaultListConverter", "columnsHelper", "modulesManager", "securityEventTypes", "$filter", "routeHelper", "securityEventsConverters", "$timeout", "base64", "objectTypeDao", "feature", "brandInfo", function (path, $q, securityEventsDao, tablePaginationHelper, defaultListConverter, columnsHelper, modulesManager, securityEventTypes, $filter, routeHelper, securityEventsConverters, $timeout, base64, objectTypeDao, feature, brandInfo) {
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('dashboard/events-list').template('events-list'),
            scope: {},
            link: function ($scope, element, attrs) {
                var pageSize = 20;
                $scope.searchAfter = undefined;
                $scope.model = {
                    filters: [
                        {
                            id: 'new',
                            type: 'current_state'
                        },
                        {
                            id: 'remediated',
                            type: 'current_state'
                        },
                        {
                            id: 'detected',
                            type: 'current_state'
                        },
                        {
                            id: 'dlp',
                            type: 'type'
                        },
                        {
                            id: 'malware',
                            type: 'type'
                        },
                        {
                            id: 'phishing',
                            type: 'type'
                        },
                        {
                            id: 'suspicious_malware',
                            type: 'type'
                        },
                        {
                            id: 'suspicious_phishing',
                            type: 'type'
                        },
                        {
                            id: 'alert',
                            type: 'type'
                        },
                        {
                            id: 'anomaly',
                            type: 'type'
                        }
                    ]
                };
                var showClicktimeProtection = modulesManager.activeSecApps().includes('clicktime_protection');
                var showOffice365Atp = modulesManager.activeSecApps().includes('office365_atp');
                if (showClicktimeProtection || showOffice365Atp) {
                    $scope.model.filters.push({
                        id: 'malicious_url',
                        type: 'type'
                    }, {
                        id: 'malicious_url_click',
                        type: 'type'
                    });
                }
                var getSavedfilters = localStorage.getItem('dashboardSecurityEventFilters');
                if (getSavedfilters) {
                    getSavedfilters = JSON.parse(getSavedfilters);
                    if (getSavedfilters[brandInfo.getCustomerDomain()]) {
                        $scope.model.filters = getSavedfilters[brandInfo.getCustomerDomain()];
                        // hotfix: remove wrong suspicious filter from saved filters
                        $scope.model.filters = _($scope.model.filters).reject(function (filter) {
                            return filter.id === 'suspicious';
                        });
                    }
                }
                var eventTimeout = $q.defer();
                $scope.loaded = false;
                $scope.dataMap = {};
                if (feature.checkpointTheme) {
                    $scope.updateTick = 60000;
                } else {
                    $scope.updateTick = 300000;
                }
                var setFilter = function (type, values, noReload) {
                    values = values || [];
                    var existing = _($scope.model.filters).chain().filter(function (filter) {
                        return filter.type === type;
                    }).pluck('id').value();
                    if (values.length !== existing.length || _(existing).intersection(values).length !== existing.length) {
                        var newFilters = _($scope.model.filters).filter(function (filter) {
                            return filter.type !== type;
                        });
                        _(values).each(function (val) {
                            newFilters.push({
                                type: type,
                                id: val
                            });
                        });
                        $scope.model.filters = newFilters;
                        if (!getSavedfilters) {
                            getSavedfilters = {};
                        }
                        getSavedfilters[brandInfo.getCustomerDomain()] = newFilters;
                        localStorage.setItem('dashboardSecurityEventFilters', JSON.stringify(getSavedfilters));
                        if (!noReload) {
                            loadData(true);
                        }
                    }
                };
                var getFilterStates = function () {
                    return _($scope.model.filters).chain().filter(function (filter) {
                        return filter.type === 'current_state';
                    }).pluck('id').value();
                };
                var getFilterTypes = function () {
                    return _($scope.model.filters).chain().filter(function (filter) {
                        return filter.type === 'type';
                    }).pluck('id').value();
                };
                $scope.filterButtons = [{
                        label: 'Type',
                        id: 'type',
                        'class': 'filter-type',
                        variants: angular.copy(securityEventTypes.data()),
                        skipAll: true,
                        type: 'selector',
                        options: {
                            multiple: true,
                            emptyLabel: 'Type',
                            showAll: false,
                            selectedLabelType: 'empty',
                            keepOpenOnLocation: true
                        },
                        onChange: function (values) {
                            setFilter('type', values, false);
                        },
                        value: getFilterTypes()
                    }];
                var tableBody = null;
                function loadQuery(offset) {
                    var filterStates = getFilterStates();
                    var filterTypes = getFilterTypes();
                    eventTimeout.resolve();
                    eventTimeout = $q.defer();
                    var result;
                    if (feature.enableSecurityEventsGQM && false) {
                        var isLoadNewEvents = !offset;
                        var searchAfter = isLoadNewEvents ? undefined : $scope.searchAfter;
                        result = securityEventsDao.list_es(searchAfter, pageSize).after(function (res) {
                            var lastRow = _.last(res.data.rows);
                            if (lastRow) {
                                $scope.searchAfter = lastRow._sort;
                            }
                        });
                    } else {
                        result = securityEventsDao.list();
                    }
                    return result.timeout(eventTimeout.promise).preFetch(objectTypeDao.entities(), 'objectTypes').params({
                        resolve: true,
                        filterEnum_current_state: filterStates.join(','),
                        filterEnum_type: filterTypes.join(','),
                        no_return_rowscount: true
                    }).pagination(offset, pageSize).order('create_time', 'desc').converter(function (input, args) {
                        return $q.when({
                            data: {
                                rows: _(input.data.rows).map(function (row) {
                                    return {
                                        original: row,
                                        'class': {},
                                        'style': {},
                                        converted: {
                                            create_time: securityEventsConverters.doubleLineDate(row.create_time),
                                            saas: securityEventsConverters.eventSaas(row.saas),
                                            type: securityEventsConverters.securityEventTypeConverter(row.type),
                                            description_short: securityEventsConverters.descriptionConverter(row.description_short, 'description_short', row, {
                                                objectTypes: args.objectTypes,
                                                disableLinks: false
                                            })
                                        }
                                    };
                                })
                            }
                        });
                    }, function (preFetches) {
                        return { objectTypes: preFetches.objectTypes };
                    });
                }
                function sortEvents(a, b) {
                    if (a.original.create_time > b.original.create_time) {
                        return -1;
                    }
                    if (a.original.create_time < b.original.create_time) {
                        return 1;
                    }
                    return b.original.id - a.original.id;
                }
                function setDataModel(data) {
                    $scope.model.data = data;
                    // $scope.model.data.sort(sortEvents);
                    $scope.dataMap = _($scope.model.data).chain().map(function (row) {
                        return [
                            row.original.id,
                            row
                        ];
                    }).object().value();
                }
                function slideDownNew(duration) {
                    var newEl = element.find('.new-row').last();
                    if (newEl.length) {
                        newEl.slideDown({
                            duration: duration,
                            easing: 'linear',
                            complete: function () {
                                newEl.removeClass('new-row');
                                $timeout(function () {
                                    slideDownNew(duration);
                                });
                            }
                        });
                    }
                }
                function loadData(force) {
                    if (force) {
                        $scope.loaded = false;
                        $scope.dataMap = {};
                        $scope.model.data = [];
                        tableBody = null;
                    }
                    return loadQuery(0).then(function (response) {
                        var firstLoading = false;
                        var data = $scope.model.data || [];
                        var newCount = 0;
                        if (data.length === 0) {
                            firstLoading = true;
                        }
                        _(response.data.rows).each(function (row) {
                            if ($scope.dataMap[row.original.id]) {
                                $scope.dataMap[row.original.id] = row;
                            } else {
                                if (firstLoading) {
                                    data.push(row);
                                } else {
                                    data.unshift(row);
                                }
                                newCount++;
                                if ($scope.loaded) {
                                    row.style.display = 'none';
                                    row['class']['new-row'] = true;
                                }
                            }
                        });
                        setDataModel(data);
                        if ($scope.loaded) {
                            $timeout(function () {
                                slideDownNew(Math.max(Math.round(400 / newCount), 1));
                            });
                        }
                        if (!tableBody) {
                            $timeout(function () {
                                tableBody = element.find('.table-body');
                                if (tableBody.length) {
                                    tableBody.off('scroll');
                                    tableBody.on('scroll', scrollWatcher);
                                    $scope.$on('$destroy', function () {
                                        tableBody.off('scroll', scrollWatcher);
                                    });
                                } else {
                                    tableBody = null;
                                }
                            });
                        }
                        $scope.loaded = true;
                    });
                }
                var haveNoMore = false;
                function loadMore() {
                    if (!$scope.loaded || $scope.loadingMore) {
                        return;
                    }
                    $scope.loadingMore = true;
                    return loadQuery($scope.model.data.length).then(function (response) {
                        if (response.data.rows.length === 0) {
                            haveNoMore = true;
                            return;
                        }
                        var data = $scope.model.data || [];
                        var addedRows = [];
                        _(response.data.rows).each(function (row) {
                            if ($scope.dataMap[row.original.id]) {
                                $scope.dataMap[row.original.id] = row;
                            } else {
                                data.push(row);
                                addedRows.push(row);
                                row.style.opacity = '0';
                            }
                        });
                        setDataModel(data);
                        $timeout(function () {
                            _(addedRows).each(function (row) {
                                delete row.style.opacity;
                            });
                        });
                    }).finally(function () {
                        $scope.loadingMore = false;
                    });
                }
                function scrollWatcher() {
                    if ($scope.loadingMore || haveNoMore) {
                        return;
                    }
                    var lastItem = tableBody.find('.table-row-outer').last();
                    if (!lastItem.length) {
                        return;
                    }
                    var lastEventTop = lastItem[0].offsetTop;
                    if (lastEventTop < tableBody.scrollTop() + tableBody.height()) {
                        loadMore();
                    }
                    return true;
                }
                $scope.processClick = function ($event) {
                    $event.stopPropagation();
                };
                $scope.widgetApi = {};
                $scope.loadData = function () {
                    return loadData();
                };
                $scope.rowClicked = function ($event, row) {
                    var filterStates = getFilterStates();
                    var filterTypes = getFilterTypes();
                    routeHelper.redirectTo('security-events', {}, {
                        qs: {
                            eventId: row.original.id,
                            filters: base64.encode(JSON.stringify({
                                resolution: 'all',
                                filters: _(filterStates).map(function (state) {
                                    return {
                                        type: 'current_state',
                                        id: state
                                    };
                                }).concat(_(filterTypes).map(function (type) {
                                    return {
                                        type: 'type',
                                        id: type
                                    };
                                }))
                            }))
                        }
                    });
                };
                function addTitle(event) {
                    if (event.currentTarget.offsetWidth < event.currentTarget.scrollWidth) {
                        if (!event.currentTarget.getAttribute('title')) {
                            event.currentTarget.setAttribute('title', event.currentTarget.textContent);
                        }
                    }
                }
                $(document).on('mouseenter', '.security-events-tip-value', addTitle);
                $scope.$on('$destroy', function () {
                    $(document).off('mouseenter', '.security-events-tip-value', addTitle);
                });
            }
        };
    }]);
}());